import { api } from "../lib/api";

// Public: only languages an admin has published (feeds the user-facing switcher).
export const fetchPublishedLanguages = () => api.get("/i18n/languages/published").then((r) => r.data);

// Public: every configured language regardless of status (e.g. for pickers
// like "request a translator for language X").
export const fetchAllLanguages = () => api.get("/i18n/languages/all").then((r) => r.data);

// Public: { key: text } for one published language (English fills any gap).
export const fetchLanguageBundle = (code) => api.get(`/i18n/bundle/${encodeURIComponent(code)}`).then((r) => r.data);

// Admin only.
export const fetchLanguageRollup = (totalKeys) => api.get("/i18n/languages", { params: { totalKeys } }).then((r) => r.data);
export const addLanguage = (payload) => api.post("/i18n/languages", payload).then((r) => r.data);
export const setLanguageStatus = (code, status) => api.patch(`/i18n/languages/${code}/status`, { status }).then((r) => r.data);
export const generateTranslations = (code, keys) => api.post(`/i18n/languages/${code}/generate`, { keys }, { timeout: 180000 }).then((r) => r.data);
export const fetchTranslations = (code) => api.get(`/i18n/translations/${code}`).then((r) => r.data);
export const saveTranslation = (code, key, text) => api.put(`/i18n/translations/${code}/${encodeURIComponent(key)}`, { text }).then((r) => r.data);
